import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

const AUTO_DISMISS_MS = 30000;

function DynamicAlert({ alert }) {
    const [currentAlert, setCurrentAlert] = useState(null);

    useEffect(() => {
        if (!alert?.msg) {
            setCurrentAlert(null);
            return;
        }

        setCurrentAlert({
            type: alert.type || "info",
            msg: alert.msg,
            id: alert.id,
        });

        const timer = setTimeout(() => {
            setCurrentAlert(null);
        }, AUTO_DISMISS_MS);

        return () => clearTimeout(timer);
    }, [alert?.id, alert?.type, alert?.msg]);

    if (!currentAlert?.msg) {
        return null;
    }

    return (
        <div
            className={`alert alert-${currentAlert.type}`}
            role="alert"
            aria-live="polite"
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "16px",
            }}
        >
            <span>{currentAlert.msg}</span>

            <button
                type="button"
                onClick={() => setCurrentAlert(null)}
                aria-label="Close alert"
                style={{
                    background: "transparent",
                    border: "none",
                    fontSize: "20px",
                    lineHeight: 1,
                    cursor: "pointer",
                    marginLeft: "12px",
                    padding: "0 4px",
                }}
            >
                &times;
            </button>
        </div>
    );
}

DynamicAlert.propTypes = {
    alert: PropTypes.shape({
        id: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
        type: PropTypes.oneOf([
            "success",
            "danger",
            "warning",
            "info",
        ]),
        msg: PropTypes.string,
    }),
};

DynamicAlert.defaultProps = {
    alert: null,
};

export default DynamicAlert;